/**
 * Indique si l'UI doit afficher Spotify comme réellement utilisable.
 * Le JWT (/auth/verify) peut rester à connected tant qu'un access token est stocké,
 * alors que GET /spotify/token peut exiger une reconnexion (refresh échoué, etc.).
 *
 * @param {boolean} jwtSpotifyConnected - user.spotify.connected depuis la session
 * @param {Object} tokenState - sortie partielle de useSpotifyToken
 * @param {boolean} tokenState.loading
 * @param {string|null} tokenState.spotifyToken
 * @param {boolean} tokenState.isExpired
 * @param {string|null} tokenState.error
 * @returns {boolean}
 */
export function isSpotifyConnectedForUi(jwtSpotifyConnected, tokenState) {
  const { loading, spotifyToken, isExpired, error } = tokenState;
  if (!jwtSpotifyConnected) return false;
  if (loading) return true;
  return Boolean(spotifyToken) && !isExpired && !error;
}
